// import React, { useMemo, useState, useCallback } from "react";
// import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
// import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
// import { Tables } from "../../../../../components/Elements/Tables/Tables";

// const AssignedForm = ({ formAllotments }) => {
//   const [searchTerm, setSearchTerm] = useState("");

//   const handleSearch = useCallback((term) => {
//     setSearchTerm(term);
//   }, []);

//   // Transform API data to table format
//   const tableData = useMemo(() => {
//     return (formAllotments || []).map((item, index) => ({
//       key: item._id,
//       serial: (<div className="text-center">{index + 1}</div>),
//       title: (<div className="text-center">{item?.template?.title || "N/A"}</div>),
//       projectName:(<div className="text-center">{item?.project?.name || "N/A"}</div>),
//       assignedOn: item?.createdAt
//         ? new Date(item.createdAt).toLocaleDateString()
//         : "N/A",
//       action: (
//         <div className="flex gap-3" title="">
//           <EyeIcon style={{ fontSize: "18px", cursor: "pointer" }} />
//         </div>
//       ),
//     }));
//   }, [formAllotments]);

//   const header = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Form Title", key: "title" },
//       { label: "Assigned On", key: "assignedOn" },
//       { label: "Project", key: "projectName" },
//       { label: "Action", key: "action" },
//     ],
//     [],
//   );

//   return (
//     <div>
//       <div className="flex gap-4 sm:gap-16 px-4 sm:px-16 pb-5">
//         <p className="text-[#06513D]  text-base sm:text-xl">Assigned Form</p>
//         <SearchBar width="300px" onSearch={handleSearch} />
//       </div>

//       <div className="overflow-x-auto">
//         <Tables
//           data={tableData.filter((item) =>
//             item.projectName.toLowerCase().includes(searchTerm.toLowerCase()),
//           )}
//           headers={header}
//           pageSize={7}
//         />
//       </div>
//     </div>
//   );
// };

// export default AssignedForm;
import React, { useMemo, useState, useCallback } from "react";
import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../../../components/Elements/Tables/Tables";
import { useNavigate, useLocation } from "react-router-dom";
import { FileText, CheckCircle } from "lucide-react";
import { Empty } from "antd";

const AssignedForm = ({ formAllotments, employeeId }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState(
    location.state?.assignedFormSearch || "",
  );
  const [activeTab, setActiveTab] = useState(
    location.state?.assignedFormTab || "assigned",
  );
  const [pageNo, setPageNo] = useState(location.state?.assignedFormPageNo || 1);

  React.useEffect(() => {
    if (
      location.state?.assignedFormPageNo !== pageNo ||
      location.state?.assignedFormSearch !== searchTerm ||
      location.state?.assignedFormTab !== activeTab
    ) {
      navigate(".", {
        replace: true,
        state: {
          ...location.state,
          assignedFormPageNo: pageNo,
          assignedFormSearch: searchTerm,
          assignedFormTab: activeTab,
        },
      });
    }
  }, [pageNo, searchTerm, activeTab, navigate, location.state]);

  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
    setPageNo(1);
  }, []);

  const filteredAllotments = useMemo(() => {
    if (activeTab === "assigned") {
      return formAllotments || [];
    }

    // Return dummy data for authorized tab
    return [
      {
        _id: "dummy1",
        project: { name: "OGB0002/OG ESG Reporting/2026/014" },
        template: { title: "Water Footprint Form (Dummy)" },
        createdAt: "2026-08-12T00:00:00.000Z",
        period: "Apr 2026 - Jun 2026",
        user: [{ endDate: "2026-09-30T00:00:00.000Z", status: "Active" }],
      },
      {
        _id: "dummy2",
        project: { name: "OGB0003/Carbon Footprint/2026" },
        template: { title: "Energy Consumption Form (Dummy)" },
        createdAt: "2026-08-10T00:00:00.000Z",
        period: "Jan 2026 - Mar 2026",
        user: [{ endDate: "2026-06-30T00:00:00.000Z", status: "Pending" }],
      },
    ];
  }, [formAllotments, activeTab]);

  // Transform API data to table format
  const tableData = useMemo(() => {
    return filteredAllotments.map((item, index) => ({
      key: item._id,
      serial: <div className="text-center">{index + 1}</div>,
      title: (
        <div className="text-center">{item?.template?.title || "N/A"}</div>
      ),
      projectName: (
        <div
          style={{
            textAlign: "center",
            wordWrap: "break-word",
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          {item?.project?.name || "N/A"}
        </div>
      ),
      assignedOn: (
        <div className="text-center">
          {item?.createdAt
            ? new Date(item.createdAt).toLocaleDateString()
            : "N/A"}
        </div>
      ),
      status: (
        <div className="text-center">{item?.user?.[0]?.status || "N/A"}</div>
      ),
      period: <div className="text-center">{item?.period || "N/A"}</div>,
      endDate: (
        <div className="text-center">
          {item?.user?.[0]?.endDate
            ? new Date(item.user[0].endDate).toLocaleDateString()
            : "N/A"}
        </div>
      ),
      formType: <div className="text-center">Standard Form</div>,
      action: (
        <div className="flex justify-center">
          <EyeIcon
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() =>
              navigate(
                `/organization/user-management/user-details/view/${item._id}`,
                {
                  state: {
                    projectId: item.project?._id || item.project,
                    templateId: item.template?._id || item.template,
                    employeeId: employeeId,
                    userSubDocId: item.user?.[0]?._id,
                    formTitle: item.template?.title,
                    formName: item.template?.title,
                  },
                },
              )
            }
          />
        </div>
      ),
      // Add raw string values for filtering
      projectNameText: item?.project?.name || "N/A",
      titleText: item?.template?.title || "N/A",
    }));
  }, [filteredAllotments, navigate, employeeId]);

  const header = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Form Title", key: "title" },
      { label: "Project", key: "projectName" },
      { label: "Period", key: "period" },
      { label: "Assigned On", key: "assignedOn" },
      { label: "End Date", key: "endDate" },
      { label: "Status", key: "status" },
      { label: "Form Type", key: "formType" },
      { label: "Action", key: "action" },
    ],
    [],
  );

  // Filter data using the raw text values
  const filteredData = useMemo(() => {
    return tableData.filter(
      (item) =>
        item.projectNameText.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.titleText.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }, [tableData, searchTerm]);

  return (
    <div className="pb-4">
      {/* Tabs - Floating outside the card container */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 pb-4">
        <div className="flex items-center gap-2 sm:gap-4 overflow-x-auto pb-2 md:pb-0 hide-scrollbar">
          <button
            onClick={() => {
              setActiveTab("assigned");
              setPageNo(1);
            }}
            className={`px-4 sm:px-6 py-2.5 rounded-lg text-sm font-semibold transition-all whitespace-nowrap ${
              activeTab === "assigned"
                ? "bg-[#06513D] text-white shadow-md"
                : "bg-white text-gray-600 border border-gray-200 hover:bg-gray-50"
            }`}
          >
            <div className="flex items-center gap-2">
              <FileText className="w-4 h-4" />
              Assigned Forms
            </div>
          </button>
          <button
            onClick={() => {
              setActiveTab("authorized");
              setPageNo(1);
            }}
            className={`px-4 sm:px-6 py-2.5 rounded-lg text-sm font-semibold transition-all whitespace-nowrap ${
              activeTab === "authorized"
                ? "bg-[#06513D] text-white shadow-md"
                : "bg-white text-gray-600 border border-gray-200 hover:bg-gray-50"
            }`}
          >
            <div className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4" />
              Authorized Forms
            </div>
          </button>
        </div>
      </div>

      {/* Main Card Container with Brand Green Border */}
      <div className="w-full bg-[#fff] overflow-hidden border border-[#3BA2B959] rounded-[10px] pt-[20px] shadow-[0px_0px_16px_0px_rgba(6,81,61,0.05)] pb-6">
        <div className="px-4 sm:px-16 pb-4">
          <SearchBar className="w-full sm:w-auto" onSearch={handleSearch} />
        </div>

        <div className="block lg:hidden px-4 sm:px-6 mt-4">
          {filteredAllotments?.length > 0 ? (
            filteredAllotments.map((item, index) => (
              <div
                key={item._id}
                className="bg-white rounded-xl shadow-lg border border-gray-100 p-5 mb-4 transform transition-all duration-300 hover:shadow-xl hover:scale-[1.02] hover:border-[#3BA2B9]"
                style={{
                  background:
                    "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
                  border: "1px solid #e0f2f1",
                }}
              >
                <div className="flex justify-between items-center mb-3 pb-2 border-b border-gray-100">
                  <span className="bg-gradient-to-r from-[#06513D] to-[#3BA2B9] text-white text-sm font-bold px-4 py-1 rounded-full">
                    #{index + 1}
                  </span>
                  <span className="text-sm text-gray-500">
                    {item?.user?.[0]?.status || "N/A"}
                  </span>
                </div>

                <div className="flex justify-between items-start mb-3">
                  <span className="text-sm font-semibold text-gray-600">
                    Project Name:
                  </span>
                  <span className="text-sm font-medium text-gray-800 text-right flex-1 ml-3">
                    {item?.project?.name || "N/A"}
                  </span>
                </div>

                <div className="flex justify-between items-start mb-3">
                  <span className="text-sm font-semibold text-gray-600">
                    Form Title:
                  </span>
                  <span className="text-sm font-medium text-gray-800 text-right flex-1 ml-3">
                    {item?.template?.title || "N/A"}
                  </span>
                </div>

                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm font-semibold text-gray-600">
                    Assigned On:
                  </span>
                  <span className="text-sm font-medium text-gray-800 bg-gray-100 px-3 py-1 rounded-full">
                    {item?.createdAt
                      ? new Date(item.createdAt).toLocaleDateString()
                      : "N/A"}
                  </span>
                </div>

                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm font-semibold text-gray-600">
                    End Date:
                  </span>
                  <span className="text-sm font-medium text-gray-800 bg-blue-50 px-3 py-1 rounded-full text-blue-700">
                    {item?.user?.[0]?.endDate
                      ? new Date(item.user[0].endDate).toLocaleDateString()
                      : "N/A"}
                  </span>
                </div>

                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm font-semibold text-gray-600">
                    Period:
                  </span>
                  <span className="text-sm font-medium text-gray-800 bg-green-50 px-3 py-1 rounded-full text-green-700">
                    {item?.period || "N/A"}
                  </span>
                </div>

                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm font-semibold text-gray-600">
                    Form Type:
                  </span>
                  <span className="text-sm font-medium text-gray-800">
                    Standard Form
                  </span>
                </div>

                <div className="flex justify-between items-center pt-3 border-t border-gray-100">
                  <span className="text-sm font-semibold text-gray-600">
                    Action:
                  </span>
                  <EyeIcon
                    className="text-[#0087A3] cursor-pointer hover:text-[#006b87] transition-transform transform hover:scale-110"
                    style={{ fontSize: "18px" }}
                    onClick={() =>
                      navigate(
                        `/organization/user-management/user-details/view/${item._id}`,
                        {
                          state: {
                            projectId: item.project?._id || item.project,
                            templateId: item.template?._id || item.template,
                            employeeId: employeeId,
                            userSubDocId: item.user?.[0]?._id,
                            formTitle: item.template?.title,
                            formName: item.template?.title,
                          },
                        },
                      )
                    }
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="py-8">
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No data"
              />
            </div>
          )}
        </div>

        <div className="hidden lg:block">
          <Tables
            data={filteredData}
            headers={header}
            pageSize={7}
            current={pageNo}
            onChange={(page) => setPageNo(page)}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignedForm;
